/**
 * Maps menu icon slugs to registered XIcon component slugs.
 */
export const NAV_ICON_ALIASES = {
  cube: 'package',
  truck: 'warehouse',
  'paper-airplane': 'package',
  buildings: 'identification-badge',
  key: 'key-round',
  'chart-line': 'trending-up',
  collection: 'list-bullets',
  'squares-2x2': 'list-bullets',
  'chart-bar': 'chart-pie-slice',
  'check-circle': 'thumbs-up',
  bell: 'chat-circle-text',
  'exclamation-circle': 'chat-circle-text',
}

/**
 * Default icon when a slug cannot be resolved.
 */
export const NAV_ICON_FALLBACK = 'list-bullets'

/**
 * Registered solid nav icon slugs.
 */
export const AVAILABLE_NAV_ICONS = new Set([
  'academy',
  'activity',
  'address-book',
  'adjustments',
  'archive',
  'arrows-right-left',
  'at',
  'badge-check',
  'banknote-arrow-up',
  'bezier-curve',
  'bot',
  'brand-parsinta',
  'calendar',
  'calendar-clock',
  'chart-column',
  'chart-pie-slice',
  'chat-circle-text',
  'circle-pause',
  'clipboard-list',
  'cog',
  'coins',
  'credit-card',
  'crosshair',
  'desktop',
  'file-text',
  'fingerprint',
  'flask-conical',
  'gift',
  'git-compare',
  'globe',
  'google-logo',
  'graduation-cap',
  'hand-coins',
  'hand-shake',
  'head-circuit',
  'history',
  'id-card',
  'identification-badge',
  'key-round',
  'landmark',
  'layers',
  'layout-dashboard',
  'layout-grid',
  'life-buoy',
  'link',
  'list-bullets',
  'list-tree',
  'lock',
  'log-in',
  'map-pin',
  'megaphone',
  'message-square-text',
  'microsoft-teams-logo',
  'package',
  'phone-call',
  'plug',
  'projector-screen-chart',
  'radar',
  'radio-tower',
  'receipt',
  'refresh-cw',
  'school',
  'scroll-text',
  'send',
  'shield',
  'shopping-bag',
  'shopping-cart',
  'sliders-horizontal',
  'smile',
  'student',
  'swatches',
  'target',
  'terminal-window',
  'thumbs-up',
  'ticket-percent',
  'tree-structure',
  'trending-up',
  'user-circle-minus',
  'user-cog',
  'user-list',
  'users',
  'users-three',
  'wallet',
  'warehouse',
  'wrench',
])

/**
 * Resolve a menu icon slug to a registered XIcon slug.
 *
 * @param {string|null|undefined} name
 * @returns {string|null}
 */
export function resolveNavIcon(name) {
  if (!name) {
    return null
  }

  const normalized = `${name}`.trim().toLowerCase()
  const aliased = NAV_ICON_ALIASES[normalized] || normalized

  if (AVAILABLE_NAV_ICONS.has(aliased)) {
    return aliased
  }

  return NAV_ICON_FALLBACK
}

/**
 * Build the global Vue component name for a nav icon slug.
 *
 * @param {string|null|undefined} name
 * @returns {string|null}
 */
export function navIconComponentName(name) {
  const resolved = resolveNavIcon(name)

  if (!resolved) {
    return null
  }

  return `x-icon-solid-${resolved}`
}
